module.exports = __webpack_public_path__ + "static/mexinavi-banner-14c6e4849813b31ff40d59820d977640.svg";